import { render, staticRenderFns } from "./ServerConfigManager.vue?vue&type=template&id=010560ac"
import script from "./ServerConfigManager.vue?vue&type=script&lang=js"
export * from "./ServerConfigManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports